import type { ReactNode } from 'react';

export const symbol_move_item: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M824-450H353q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h471l-68-68q-9-9-9-21t8.61-21q9.39-9 21.89-9t21.5 9l120 119q9 9 9 21t-9 21L799-339q-8.8 9-20.9 8.5-12.1-.5-21.49-9.5-8.61-9-8.61-21.5t9-21.5l67-67ZM580-600v-180H180v600h400v-180q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v180q0 24.75-17.62 42.37Q604.75-120 580-120H180q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h400q24.75 0 42.38 17.62Q640-804.75 640-780v180q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Z"
		/>
	</svg>
);
